<template>
    <div>
      <div class="container_equipamento">
        <GroupDetail
           :templateid="templateid"
           :dadosGrupo="dadosGrupo"
           @voltaParaGrupo="voltaParaGrupo"
           @addNovaEtapa="addNovaEtapa"
           @editarEtapa="editarEtapa"
           @editaSubEtapa="editaSubEtapa"
           @addNovaSubEtapa="addNovaSubEtapa"
           @novaEtapaTemplatePergunta="novaEtapaTemplatePergunta"
           @addNovaSubEtapaObjSemNovaEtapa="addNovaSubEtapaObjSemNovaEtapa"
           @addNovaPerguntaParaSubEtapa="addNovaPerguntaParaSubEtapa"
           @addNovaPerguntaEtapaSubCriada="addNovaPerguntaEtapaSubCriada"
           @ExcluirPerguntaTemplateDetalheCriado="ExcluirPerguntaTemplateDetalheCriado"
           @ExcluirPerguntaTemplateDetalheSubEtapa="ExcluirPerguntaTemplateDetalheSubEtapa"
           @ExcluirPerguntaTemplateDetalheEtapa="ExcluirPerguntaTemplateDetalheEtapa"
           @removerSubEtapaEtapaCriada="removerSubEtapaEtapaCriada"
           @removerSubEtapaAgEnvioEtapa="removerSubEtapaAgEnvioEtapa"
           @ExcluirPerguntaTemplate="ExcluirPerguntaTemplate"
           @RemoverEdicaoExcluirPerguntaTemplate="RemoverEdicaoExcluirPerguntaTemplate"
           @ExcluirSubEtapasEtapasTemplateDetalhe="ExcluirSubEtapasEtapasTemplateDetalhe"
           @removerExclusaoEtapaSubEtapa="removerExclusaoEtapaSubEtapa"
           @EditaTemplatePergunta="EditaTemplatePergunta"
           @editarEmMemoriaNovaPerguntaParaEtapa="editarEmMemoriaNovaPerguntaParaEtapa"
           @editarEmMemoriaNovaPerguntaParaSubEtapa="editarEmMemoriaNovaPerguntaParaSubEtapa"
           @EditaTemplateNovaPergunta="EditaTemplateNovaPergunta"
           @addNovaPerguntaImagem="addNovaPerguntaImagem"
           @EditarNovaPerguntaImagem="EditarNovaPerguntaImagem"
           @removerImagemNova="removerImagemNova"
           @removerEtapaEstatica="removerEtapaEstatica"
           @removerEtapaEquipamentoEstatica="removerEtapaEquipamentoEstatica"
           ref="grupoDetalhesTemplate">
          </GroupDetail>
      </div>
    </div>
</template>

<script>
import templateDetail from './templateDetail'
export default templateDetail
</script>
  <style scoped>
  .container_equipamento {
    width: 100%;
    height: fit-content;
    margin-top: 2rem;
  }

 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/templateDetail.vue